import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  toast;

  constructor(private toastCtrl: ToastController) {}

  showErrorToast(message) {
    try {
      this.toast.dismiss();
    } catch (e) {}

    this.toast = this.toastCtrl
      .create({
        message,
        animated: true,
        duration: 4000,
        position: 'bottom',
        cssClass: 'errorToast',
      })
      .then((toastData) => toastData.present());
  }

  showSuccessToast(message = 'Save Successful!') {
    try {
      this.toast.dismiss();
    } catch (e) {}

    this.toast = this.toastCtrl
      .create({
        message,
        animated: true,
        duration: 4000,
        position: 'bottom',
        cssClass: 'successToast',
      })
      .then((toastData) => toastData.present());
  }

  showOnceErrorToast(error: string) {
    this.toastCtrl
      .dismiss()
      .then((obj) => {})
      .catch(() => {})
      .finally(() => {
        this.showErrorToast(error);
      });
  }

  async dismiss() {
    try {
      await this.toastCtrl.dismiss(this.toast);
    } catch (e) {}
  }
}
